<div class="entete_famille">
  <p class="titre_section">{{ famille() }}</p>
  @if (chargementEnCours()) {
    <app-spinner size="lg" ariaLabel="Chargement du service" />
  }
</div>

<!-- Partenaires ITR (Connect:PartnerConfigurations) : la bascule déplie la liste des codes interface
     de l'accès au client, enregistrée par un bouton ; la désactivation d'un accès existant se valide -->
@for (tuile of tuiles; track tuile.partenaire.index) {
  <div class="ligne_partenaire">
    <app-toggle
      [checked]="tuile.cochee"
      (checkedChange)="basculer(tuile, $event)"
      [label]="tuile.partenaire.partnerName || 'Partenaire ' + tuile.partenaire.index"
    />
    @if (tuile.codesADefinir) {
      <app-pill label="Codes à définir" tone="warning" />
    }
    <button
      type="button"
      appButton
      variant="ghost"
      iconOnly
      icon="edit"
      label="Modifier les informations du partenaire"
      appTooltip="Modifier les informations du partenaire"
      (click)="modifierPartenaire(tuile.partenaire)"
    ></button>
  </div>

  @if (!tuile.cochee && tuile.accesExistant) {
    <div class="tuile_interface tuile_suppression">
      <p class="texte_suppression">
        Ce client est encore activé chez ce partenaire : valider pour retirer son accès et ses codes interface de l'App
        Configuration.
      </p>
      <div class="actions_tuile">
        <button
          type="button"
          appButton
          variant="danger"
          icon="trash"
          [disabled]="enregistrementEnCours() || chargementEnCours()"
          (click)="supprimerAccesPartenaire(tuile)"
        >
          Valider la suppression
        </button>
      </div>
    </div>
  }

  @if (tuile.cochee) {
    <div class="tuile_interface">
      <div class="liste_codes">
        @for (controle of tuile.codes.controls; track controle; let rang = $index) {
          <div class="ligne_code">
            <app-form-field [label]="'Code interface ' + (rang + 1)" [required]="rang === 0">
              <app-input [formControl]="controle" [allowedChars]="chiffresSeulement" inputMode="numeric" />
              @if (erreurCode(tuile, rang); as erreur) {
                <span appFieldError>{{ erreur }}</span>
              }
            </app-form-field>
            <button
              type="button"
              appButton
              variant="ghost"
              iconOnly
              icon="trash"
              label="Retirer ce code"
              appTooltip="Retirer ce code"
              [disabled]="tuile.codes.length === 1"
              (click)="retirerCode(tuile, rang)"
            ></button>
          </div>
        }
      </div>

      <div class="actions_tuile">
        <button
          type="button"
          appButton
          variant="outline"
          icon="plus"
          [disabled]="!peutAjouterCode(tuile)"
          (click)="ajouterCode(tuile)"
        >
          Ajouter un code
        </button>
        <button
          type="button"
          appButton
          variant="primary"
          [disabled]="enregistrementEnCours() || chargementEnCours() || !peutEnregistrerAccesPartenaire(tuile)"
          (click)="enregistrerAccesPartenaire(tuile)"
        >
          Enregistrer
        </button>
      </div>
    </div>
  }
}

<!-- Applications client (Connect:ClientConfigurations) : la bascule déplie la visibilité de l'accès,
     enregistrée par un bouton ; la désactivation retire l'accès existant directement.
     Suivi par tuile (identité) : chaque chargement recrée les bascules, qui relisent leur état dans
     le store. app-toggle se retourne lui-même au clic : suivies par index, une bascule restée
     « true » dans le store ne serait pas resynchronisée après un échec -->
@for (tuile of tuilesApplications; track tuile) {
  <div class="ligne_partenaire">
    <app-toggle
      [checked]="tuile.cochee"
      [disabled]="enregistrementEnCours() || chargementEnCours()"
      (checkedChange)="basculerAcces(tuile, $event)"
      [label]="tuile.application.clientName || 'Application ' + tuile.application.index"
    />
    @if (tuile.visibiliteADefinir) {
      <app-pill label="Visibilité à définir" tone="warning" />
    }
    <button
      type="button"
      appButton
      variant="ghost"
      iconOnly
      icon="edit"
      label="Modifier les informations de l'application"
      appTooltip="Modifier les informations de l'application"
      (click)="modifierApplication(tuile.application)"
    ></button>
  </div>

  @if (!tuile.cochee && tuile.accesExistant) {
    <div class="tuile_interface tuile_suppression">
      <p class="texte_suppression">
        Ce client a encore accès à cette application : valider pour retirer l'accès, sa visibilité et son login de l'App
        Configuration.
      </p>
      <div class="actions_tuile">
        <button
          type="button"
          appButton
          variant="danger"
          icon="trash"
          [disabled]="enregistrementEnCours() || chargementEnCours()"
          (click)="supprimerAcces(tuile)"
        >
          Valider la suppression
        </button>
      </div>
    </div>
  }

  @if (tuile.cochee) {
    <div class="tuile_interface">
      <form [formGroup]="tuile.formulaire" class="ligne_interface">
        <app-form-field label="Visibilité">
          <app-segmented-control
            [options]="optionsVisibilite"
            [value]="tuile.formulaire.controls.visibilite.value"
            (valueChange)="tuile.formulaire.controls.visibilite.setValue($event)"
            ariaLabel="Visibilité de l'accès"
          />
        </app-form-field>

        @if (tuile.formulaire.controls.visibilite.value === 'Restricted') {
          <app-form-field label="Identifiant du login Aparté" [required]="true">
            <app-input formControlName="loginId" [allowedChars]="chiffresSeulement" inputMode="numeric" />
            @if (loginIdInvalide(tuile)) {
              <span appFieldError>Entier positif, au plus 2147483647</span>
            }
          </app-form-field>
        }
      </form>

      <div class="actions_tuile">
        <button
          type="button"
          appButton
          variant="primary"
          [disabled]="enregistrementEnCours() || chargementEnCours() || !peutEnregistrerAcces(tuile)"
          (click)="enregistrerAcces(tuile)"
        >
          Enregistrer
        </button>
      </div>
    </div>
  }
}

<!-- Fronts web (Connect:FrontConfigurations) : l'accès au client est le seul réglage, la bascule
     l'écrit directement dans le store. Suivi par identité, comme les applications -->
@for (tuile of tuilesFronts; track tuile) {
  <div class="ligne_partenaire">
    <app-toggle
      [checked]="tuile.cochee"
      [disabled]="enregistrementEnCours() || chargementEnCours()"
      (checkedChange)="basculerAccesFront(tuile, $event)"
      [label]="tuile.front.frontName || 'Front ' + tuile.front.index"
    />
    <button
      type="button"
      appButton
      variant="ghost"
      iconOnly
      icon="edit"
      label="Modifier les informations du front"
      appTooltip="Modifier les informations du front"
      (click)="modifierFront(tuile.front)"
    ></button>
  </div>
}

<div class="actions_famille">
  @if (porteDesPartenaires()) {
    <button type="button" appButton variant="outline" icon="plus" (click)="modifierPartenaire()">
      Ajouter un partenaire
    </button>
  }
  @if (porteDesApplications()) {
    <button type="button" appButton variant="outline" icon="plus" (click)="modifierApplication()">
      Ajouter une application
    </button>
  }
  @if (porteDesFronts()) {
    <button type="button" appButton variant="outline" icon="plus" (click)="modifierFront()">Ajouter un front</button>
  }
</div>
